export const LOCATION_NAMES_MAPPING = {
  wa: 'Perth',
  sa: 'Adelaide',
  qld: 'Brisbane',
  nsw: 'Sydney',
  vic: 'Melbourne',
  tas: 'Hobart',
  international: 'International',
  nnz: 'NZ - North Island',
  snz: 'NZ- South Island',
  act: 'Canberra',
  nt: 'Darwin',
  nz: 'New Zealand',
};

export const LOCATION_MAPPINGS = {
  wa: {
    title: 'Businesses for Sale in Perth',
    description:
      'Discover a wide range of profitable businesses for sale in Perth Western Australia. Resolve makes buying and selling businesses easy.',
  },
  sa: {
    title: 'Businesses for Sale in Adelaide',
    description:
      'Discover a wide range of profitable businesses for sale in Adelaide South Australia. Resolve makes buying and selling businesses easy.',
  },
  qld: {
    title: 'Businesses for Sale in Brisbane',
    description:
      'Discover a wide range of profitable businesses for sale in Brisbane Queensland. Resolve makes buying and selling businesses easy.',
  },
  nsw: {
    title: 'Businesses for Sale in Sydney',
    description:
      'Discover a wide range of profitable businesses for sale in Sydney New South Wales. Resolve makes buying and selling businesses easy.',
  },
  vic: {
    title: 'Businesses for Sale in Melbourne',
    description:
      'Discover a wide range of profitable businesses for sale in Melbourne Victoria. Resolve makes buying and selling businesses easy.',
  },
  tas: {
    title: 'Businesses for Sale in Hobart',
    description:
      'Discover a wide range of profitable businesses for sale in Hobart Tasmania. Resolve makes buying and selling businesses easy.',
  },
  nnz: {
    title: 'Businesses for Sale in New Zealand - North Island',
    description:
      'Discover a wide range of profitable businesses for sale in New Zealand - North Island. Resolve makes buying and selling businesses easy.',
  },
  snz: {
    title: 'Businesses for Sale in New Zealand - South Island',
    description:
      'Discover a wide range of profitable businesses for sale in New Zealand - South Island. Resolve makes buying and selling businesses easy.',
  },
  nz: {
    title: 'Businesses for Sale in New Zealand',
    description:
      'Discover a wide range of profitable businesses for sale in New Zealand. Resolve makes buying and selling businesses easy.',
  },
  international: {
    title: 'Businesses for Sale Internationaly',
    description:
      'Discover a wide range of profitable businesses for sale Internationaly. Resolve makes buying and selling businesses easy.',
  },
};

export const INDUSTRY_MAPPINGS = {
  'aerospace-and-defense': {
    title: 'Aerospace & Defense Businesses for Sale in Australia',
    description:
      'Browse on the Resolve marketplace for Aerospace & Defense businesses for sale. Contact our team of professionals today.',
  },
  'air-freight-and-logistics': {
    title: 'Air Freight & Logistics Businesses for Sale in Australia',
    description:
      'Browse on the Resolve marketplace for Air Freight & Logistics businesses for sale. Contact our team of professionals today.',
  },
  airlines: {
    title: 'Airlines Businesses for Sale in Australia',
    description:
      'Browse on the Resolve marketplace for Airline businesses for sale. Contact our team of professionals today.',
  },
  'auto-components': {
    title: 'Auto Parts & Components Businesses for Sale in Australia',
    description:
      'Browse on the Resolve marketplace for Auto Parts & Components businesses for sale. Contact our team of professionals today.',
  },
  automobiles: {
    title: 'Automobiles Businesses for Sale in Australia',
    description:
      'Browse on the Resolve marketplace for Automobile businesses for sale. Contact our team of professionals today.',
  },
  banks: {
    title: 'Banks Businesses for Sale in Australia',
    description:
      'Browse on the Resolve marketplace for Banking and Loan business for sale. Contact our team of professionals today.',
  },
  beverages: {
    title: 'Beverages Businesses for Sale in Australia',
    description:
      'Browse on the Resolve marketplace for Beverage businesses for sale. Contact our team of professionals today.',
  },
  biotechnology: {
    title: 'Biotechnology Businesses for Sale in Australia',
    description:
      'Browse on the Resolve marketplace for Biotechnology businesses for sale. Contact our team of professionals today.',
  },
  'building-products': {
    title: 'Building Business for Sale in Australia',
    description:
      'Browse on the Resolve marketplace for Building businesses for sale. Contact our team of professionals today.',
  },
  'capital-markets': {
    title: 'Capital Markets Businesses for Sale in Australia',
    description:
      'Browse on the Resolve marketplace for Capital Markets businesses for sale. Contact our team of professionals today.',
  },
  chemicals: {
    title: 'Chemicals Businesses for Sale in Australia',
    description:
      'Browse on the Resolve marketplace for Chemicals businesses for sale. Contact our team of professionals today.',
  },
  'commercial-services-and-supplies': {
    title: 'Commercial Services & Supplies Businesses for Sale in Australia',
    description:
      'Browse on the Resolve marketplace for Commercial Services & Supplies businesses for sale. Contact our team of professionals today.',
  },
  communications: {
    title: 'Communications Businesses for Sale in Australia',
    description:
      'Browse on the Resolve marketplace for Communications businesses for sale. Contact our team of professionals today.',
  },
  'communications-equipment': {
    title: 'Communications Equipment Businesses for Sale',
    description:
      'Browse on the Resolve marketplace for Communications Equipment businesses for sale. Contact our team of professionals today.',
  },
  'construction-containers-and-packaging': {
    title: 'Containers & Packaging Businesses for Sale',
    description:
      'Browse on the Resolve marketplace for Construction, Containers & Packaging businesses for sale. Contact our team of professionals today.',
  },
  distributors: {
    title: 'Distributors Businesses for Sale in Australia',
    description:
      'Browse on the Resolve marketplace for Distributor businesses for sale. Contact our team of professionals today.',
  },
  'diversified-consumer-services': {
    title: 'Diversified Consumer Services Businesses for Sale',
    description:
      'Browse on the Resolve marketplace for Diversified Consumer Services businesses for sale. Contact our team of professionals today.',
  },
  'diversified-telecommunication-services': {
    title: 'Diversified Telecommunication Services Businesses for Sale',
    description:
      'Browse on the Resolve marketplace for Diversified Telecommunication Services businesses for sale. Contact our team of professionals today.',
  },
  'electronic-equipment-instruments-and-components': {
    title: 'Electronic Businesses for Sale in Australia',
    description:
      'Browse on the Resolve marketplace for Electronic Equipment, Instruments & Components businesses for sale. Contact our team of professionals today.',
  },
  'equity-real-estate-investment-trusts-reits': {
    title: 'Equity Real Estate Investment Trusts Businesses for Sale',
    description:
      'Browse on the Resolve marketplace for Equity Real Estate Investment Trusts (REITs) businesses for sale. Contact our team of professionals today.',
  },
  'finance-insurance-and-real-estate': {
    title: 'Finance Insurance Businesses for Sale',
    description:
      'Browse on the Resolve marketplace for Finance Insurance businesses for sale. Contact our team of professionals today.',
  },
  'food-products': {
    title: 'Food Products Businesses for Sale',
    description:
      'Browse on the Resolve marketplace for Food Products businesses for sale. Contact our team of professionals today.',
  },
  'health-care-equipment-and-supplies': {
    title: 'Health Care Businesses for Sale',
    description:
      'Browse on the Resolve marketplace for Health Care businesses for sale. Contact our team of professionals today.',
  },
  'health-care-providers-and-services': {
    title: 'Health Care Businesses for Sale',
    description:
      'Browse on the Resolve marketplace for Health Care businesses for sale. Contact our team of professionals today.',
  },
  'health-care-technology': {
    title: 'Health Care Businesses for Sale',
    description:
      'Browse on the Resolve marketplace for Health Care businesses for sale. Contact our team of professionals today.',
  },
  'hotels-restaurants-and-leisure': {
    title: 'Hotels & Restaurants Businesses for Sale in Australia',
    description:
      'Browse on the Resolve marketplace for Hotels & Restaurants businesses for sale. Contact our team of professionals today.',
  },
  'household-durables': {
    title: 'Household Durables Businesses for Sale in Australia',
    description:
      'Browse on the Resolve marketplace for Household Durables businesses for sale. Contact our team of professionals today.',
  },
  'household-products': {
    title: 'Household Products Businesses for Sale in Australia',
    description:
      'Browse on the Resolve marketplace for Household Products businesses for sale. Contact our team of professionals today.',
  },
  'independent-power-and-renewable-electricity-producers': {
    title: 'Renewable Electricity Producer Businesses for Sale',
    description:
      'Browse on the Resolve marketplace for Independent Power and Renewable Electricity Producers businesses for sale. Contact our team of professionals today.',
  },
  'industrial-conglomerates': {
    title: 'Industrial Conglomerates Businesses for Sale',
    description:
      'Browse on the Resolve marketplace for Industrial Conglomerates businesses for sale. Contact our team of professionals today.',
  },
  insurance: {
    title: 'Insurance Businesses for Sale in Australia',
    description:
      'Browse on the Resolve marketplace for Insurance businesses for sale. Contact our team of professionals today.',
  },
  'internet-software-and-services': {
    title: 'Internet Software & Services Businesses for Sale',
    description:
      'Browse on the Resolve marketplace for Internet Software & Services businesses for sale. Contact our team of professionals today.',
  },
  'it-services': {
    title: 'IT Services Businesses for Sale in Australia',
    description:
      'Browse on the Resolve marketplace for IT Services businesses for sale. Contact our team of professionals today.',
  },
  'leisure-products': {
    title: 'Leisure Businesses for Sale in Australia',
    description:
      'Browse on the Resolve marketplace for Leisure Products businesses for sale. Contact our team of professionals today.',
  },
  'life-sciences-tools-and-services': {
    title: 'Life Science Tools & Service Businesses for Sale',
    description:
      'Browse on the Resolve marketplace for Life Sciences Tools & Services businesses for sale. Contact our team of professionals today.',
  },
  machinery: {
    title: 'Machinery Businesses for Sale in Australia',
    description:
      'Browse on the Resolve marketplace for Machinery businesses for sale. Contact our team of professionals today.',
  },
  manufacturing: {
    title: 'Manufacturing Businesses for Sale in Australia',
    description:
      'Browse on the Resolve marketplace for Manufacturing businesses for sale. Contact our team of professionals today.',
  },
  marine: {
    title: 'Marine Businesses for Sale in Australia',
    description:
      'Browse on the Resolve marketplace for Marine businesses for sale. Contact our team of professionals today.',
  },
  'marketing-advertising-sales': {
    title: 'Marketing & Advertising Businesses for Sale',
    description:
      'Browse on the Resolve marketplace for Marketing Advertising Sales businesses for sale. Contact our team of professionals today.',
  },
  media: {
    title: 'Media Businesses for Sale in Australia',
    description:
      'Browse on the Resolve marketplace for Media businesses for sale. Contact our team of professionals today.',
  },
  mining: {
    title: 'Mining Businesses for Sale in Australia',
    description:
      'Browse on the Resolve marketplace for Mining businesses for sale. Contact our team of professionals today.',
  },
  'mortgage-real-estate-investment-trusts-reits': {
    title: 'Mortgage Real Estate Investment Trusts Businesses for Sale',
    description:
      'Browse on the Resolve marketplace for Mortgage Real Estate Investment Trusts (REITs) businesses for sale. Contact our team of professionals today.',
  },
  oil: {
    title: 'Oil Businesses for Sale in Australia',
    description:
      'Browse on the Resolve marketplace for Oil businesses for sale. Contact our team of professionals today.',
  },
  'gas-and-consumable-fuels': {
    title: 'Gas & Fuels Businesses for Sale in Australia',
    description:
      'Browse on the Resolve marketplace for Gas & Consumable Fuels businesses for sale. Contact our team of professionals today.',
  },
  'online-recruitment-and-training': {
    title: 'Online Recruitment & Training Businesses for Sale',
    description:
      'Browse on the Resolve marketplace for Online Recruitment and Training businesses for sale. Contact our team of professionals today.',
  },
  'paper-and-forest-products': {
    title: 'Paper & Forest Products Businesses for Sale',
    description:
      'Browse on the Resolve marketplace for Paper & Forest Products businesses for sale. Contact our team of professionals today.',
  },
  'personal-products': {
    title: 'Personal Products Businesses for Sale in Australia',
    description:
      'Browse on the Resolve marketplace for Personal Products businesses for sale. Contact our team of professionals today.',
  },
  pharmaceuticals: {
    title: 'Pharmaceuticals Businesses for Sale in Australia',
    description:
      'Browse on the Resolve marketplace for Pharmaceuticals businesses for sale. Contact our team of professionals today.',
  },
  'professional-services': {
    title: 'Professional Service Businesses for Sale in Australia',
    description:
      'Browse on the Resolve marketplace for Professional Service businesses for sale. Contact our team of professionals today.',
  },
  'real-estate-management-and-development': {
    title: 'Real Estate Management & Development Businesses for Sale',
    description:
      'Browse on the Resolve marketplace for Real Estate Management & Development businesses for sale. Contact our team of professionals today.',
  },
  'retail-trade': {
    title: 'Retail Trade Businesses for Sale in Australia',
    description:
      'Browse on the Resolve marketplace for Retail Trade businesses for sale. Contact our team of professionals today.',
  },
  'road-and-rail': {
    title: 'Road & Rail Businesses for Sale in Australia',
    description:
      'Browse on the Resolve marketplace for Road & Rail businesses for sale. Contact our team of professionals today.',
  },
  'semiconductors-and-semiconductor-equipment': {
    title: 'Semiconductors & Semiconductor Equipment',
    description:
      'Browse on the Resolve marketplace for Semiconductors and Semiconductor Equipment businesses for sale. Contact our team of professionals today.',
  },
  software: {
    title: 'Software Businesses for Sale in Australia',
    description:
      'Browse on the Resolve marketplace for Software businesses for sale. Contact our team of professionals today.',
  },
  'textiles-apparel-and-luxury-goods': {
    title: 'Textiles, Apparel & Luxury Goods',
    description:
      'Browse on the Resolve marketplace for Textiles, Apparel & Luxury Goods businesses for sale. Contact our team of professionals today.',
  },
  tobacco: {
    title: 'Tobacco Businesses for Sale in Australia',
    description:
      'Browse on the Resolve marketplace for Tobacco businesses for sale. Contact our team of professionals today.',
  },
  'trading-companies-and-distributors': {
    title: 'Trading & Distributors Businesses for Sale',
    description:
      'Browse on the Resolve marketplace for Trading Companies & Distributors businesses for sale. Contact our team of professionals today.',
  },
  transport: {
    title: 'Transportation Infrastructure Businesses for Sale',
    description:
      'Browse on the Resolve marketplace for Transportation Infrastructure businesses for sale. Contact our team of professionals today.',
  },
  'transportation-infrastructure': {
    title: 'Transportation Infrastructure Businesses for Sale',
    description:
      'Browse on the Resolve marketplace for Transportation Infrastructure businesses for sale. Contact our team of professionals today.',
  },
  'wholesale-trade': {
    title: 'Wholesale Trade Businesses for Sale in Australia',
    description:
      'Browse on the Resolve marketplace for Wholesale Trade businesses for sale. Contact our team of professionals today.',
  },
  'wireless-telecommunication-services': {
    title: 'Wireless Telecommunication Services Businesses for Sale',
    description:
      'Browse on the Resolve marketplace for Wireless Telecommunication Services businesses for sale. Contact our team of professionals today.',
  },
  'electronic-equipment': {
    title: 'Electronic Businesses for Sale in Australia',
    description:
      'Browse on the Resolve marketplace for Electronic Equipment, Instruments & Components businesses for sale. Contact our team of professionals today.',
  },
  'energy-equipment-and-services': {
    title: 'Energy Equipment & Services Businesses for Sale in Australia',
    description:
      'Browse on the Resolve marketplace for Energy Equipment & Services businesses for sale. Contact our team of professionals today.',
  },
  services: {
    title: 'Services Businesses for Sale in Australia',
    description:
      'Browse on the Resolve marketplace for Services businesses for sale. Contact our team of professionals today.',
  },
  'technology-hardware-storage-and-peripherals': {
    title:
      'Technology Hardware Storage & Peripherals Businesses for Sale in Australia',
    description:
      'Browse on the Resolve marketplace for Technology Hardware Storage & Peripherals businesses for sale. Contact our team of professionals today.',
  },
  utilities: {
    title: 'Utilities Businesses for Sale in Australia',
    description:
      'Browse on the Resolve marketplace for Utilities businesses for sale. Contact our team of professionals today.',
  },
  other: {
    title: 'Other Businesses for Sale in Australia',
    description:
      'Browse on the Resolve marketplace for Other businesses for sale. Contact our team of professionals today.',
  },
};
